import { getMainServiceCategories } from './getMainServiceCategories'
import { getServiceCategoryDetails } from './getServiceCategoriesDetails'
import { getServicesMainPage } from './getServicesMainPage'
import { getServicesPageBlock } from './getServicePageBlock'
import { getServiceCategoryPageBlocks } from './getServiceCategoryPageBlocks'
import { getService } from './getService'
import { getServiceCategoriesDetailsSeo } from './getServiceCategoriesDetailsSeo'
import { getServiceMainPageSeo } from './getServiceMainPageSeo'
import { getServiceSeo } from './getServiceSeo'
import { getAllServiceCategories } from './getAllServiceCategories'
import { getAllServices } from '@/shared/api/strapi/requests/service/getAllServices'
import { getAllDecisions } from './getAllDecisions'

export * from './getMainServiceCategories'
export * from './getServiceCategoriesDetails'
export * from './getServicesMainPage'
export * from './getServicePageBlock'
export * from './getServiceCategoryPageBlocks'
export * from './getService'
export * from './getServiceMainPageSeo'
export * from './getServiceSeo'
export * from './getServiceCategoriesDetailsSeo'
export * from './getAllServiceCategories'
export * from './getAllServices'
export * from './getAllDecisions'

export const serviceApi = {
  getMainServiceCategories,
  getServiceCategoryDetails,
  getServicesMainPage,
  getServicesPageBlock,
  getServiceCategoryPageBlocks,
  getService,
  getServiceCategoriesDetailsSeo,
  getServiceMainPageSeo,
  getServiceSeo,
  getAllServiceCategories,
  getAllServices,
  getAllDecisions,
}
